var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderwritingAppliedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.8309L12.0832 11.5602C11.7296 11.947 11.2501 12.1642 10.7501 12.1642C10.2501 12.1642 9.77053 11.947 9.41692 11.5602C9.06281 11.1743 8.58332 10.9576 8.08345 10.9576C7.58359 10.9576 7.10409 11.1743 6.74998 11.5602M0.75 12.1642H1.86636C2.19248 12.1642 2.35554 12.1642 2.50899 12.1274C2.64504 12.0947 2.7751 12.0408 2.8944 11.9677C3.02895 11.8853 3.14425 11.77 3.37486 11.5394L11.75 3.16421C12.3023 2.61193 12.3023 1.7165 11.75 1.16421C11.1977 0.611929 10.3023 0.611929 9.75002 1.16421L1.37484 9.53937C1.14424 9.76998 1.02894 9.88528 0.94648 10.0198C0.873375 10.1391 0.819503 10.2692 0.78684 10.4052C0.75 10.5587 0.75 10.7217 0.75 11.0479V12.1642Z",
    stroke: "#0A544F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwritingAppliedIcon);
export default __webpack_public_path__ + "static/media/underwriting-applied-icon.072b319b900c9d7a6e41796aaf0a69e0.svg";
export { ForwardRef as ReactComponent };